import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import VehiclePicker from "@/components/VehiclePicker";

// Fenêtre « Nouveau / Modifier le véhicule », partagée par la page Clients et le formulaire de mission.
// state = { open, item (véhicule à modifier ou null), clientId } ; onSaved(véhicule enregistré).
export default function VehicleDialog({ state, setState, onSaved }) {
  const empty = { brand: "", model: "", plate: "", color: "", notes: "" };
  const [form, setForm] = useState(empty);
  useEffect(() => { setForm(state.item ? { ...empty, ...state.item } : empty); }, [state.open, state.item]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const close = () => setState({ open: false, item: null, clientId: null });
  const save = async () => {
    if (!form.brand?.trim()) { toast.error("La marque est obligatoire"); return; }
    const payload = { ...form, client_id: state.clientId };
    try {
      const { data } = state.item ? await api.patch(`/vehicles/${state.item.id}`, payload) : await api.post("/vehicles", payload);
      toast.success("Enregistré"); onSaved(data); close();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <Dialog open={state.open} onOpenChange={(o) => setState({ ...state, open: o })}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle className="font-display">{state.item ? "Modifier le véhicule" : "Nouveau véhicule"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <VehiclePicker key={`${state.item?.id || "new"}-${state.open}`} initialBrand={state.item?.brand || ""} initialModel={state.item?.model || ""} onChange={(brand, model) => setForm((f) => ({ ...f, brand, model }))} />
          {[["plate", "Immatriculation (facultative)"], ["color", "Couleur"]].map(([k, l]) => (
            <div key={k} className="space-y-1.5"><Label>{l}</Label><Input value={form[k]} onChange={(e) => set(k, e.target.value)} data-testid={`vehicle-${k}`} /></div>
          ))}
          <div className="space-y-1.5"><Label>Notes (ex. clé au concierge)</Label><Textarea value={form.notes} onChange={(e) => set("notes", e.target.value)} data-testid="vehicle-notes" /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={close}>Annuler</Button><Button onClick={save} data-testid="vehicle-save">Enregistrer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
